import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const Invoice = () => {
  const data = [
    ['Month', 'Invoices Processed'],
    ['January', 120],
    ['February', 130],
    ['March', 125],
    ['April', 140],
    ['May', 135],
  ];

  const options = {
    title: 'Invoices Processed',
    hAxis: { title: 'Month' },
    vAxis: { title: 'Invoices Processed' },
    legend: { position: 'top' },
    bar: { groupWidth: '75%' },
    colors: ['#4CAF50'],
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="ColumnChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default Invoice;